
@if ( isMobile=='true' ){
  <nav class="" tabindex="-1" id="mobilemenu" aria-label="mobile menu">
    <button class="btn btn-outline-primary me-0 ms-2 fw-bold d-md-none" type="button" (click)="open(content)">Menu</button>
    <ng-template #content let-offcanvas>
      <div class="offcanvas-body">
        <button type="button" class="btn-close float-end" aria-label="Close" (click)="offcanvas.dismiss()"></button>
        <div class="pt-0">
          <div ngbDropdown class="dropdown d-inline-block" placement="bottom-start">
            <button type="button" class="btn btn-link mx-1 fw-bold text-black" id="dropdown_list" ngbDropdownToggle title="Available to" style="text-decoration: none;">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill fs-5 text-black" viewBox="0 0 16 16">
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
              </svg> {{ userName }}
            </button>
            <div ngbDropdownMenu class="bg-white">
              <button ngbDropdownItem class="dropdown-item"><a class="dropdown-item" href="{{ myProfileLink }}" target="_blank">My Profile *</a></button>
              @if ( showO365Logout ) {
                <button ngbDropdownItem class="dropdown-item"><a class="dropdown-item" href="#" (click)="logoutO365()">Disconnect O365</a></button>
              }
              <button ngbDropdownItem class="dropdown-item"><a class="dropdown-item" href="{{ helpLink }}" target="_blank">Help</a></button>
              <div class="dropdown-divider"></div>
              <button ngbDropdownItem class="dropdown-item"><a class="dropdown-item" [routerLink]="['/logout']">Sign out</a></button>
            </div>
          </div>

          <ul class="nav flex-column">
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="offcanvas.dismiss()">
              <a class="nav-link active" aria-current="page" [routerLink]="['/']" data-bs-dismiss="offcanvas" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" width="1em" fill="currentColor" class="bi bi-house-door-fill" viewBox="0 0 16 16">
                <path
                  d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5z">
                </path>
              </svg> Home</a>
            </li>
            <li class="nav-item" routerLinkActive="active" (click)="offcanvas.dismiss()">
              <a class="nav-link" [routerLink]="['/search']" data-bs-dismiss="offcanvas" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-fill" viewBox="0 0 16 16">
                <path
                  d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z" />
                </svg> Apps and services</a>
              </li>
              @for( i of externalIcons; track i.id ) {
                @if ( !i.is_college ) {
                  <li class="nav-item" routerLinkActive="active" (click)="offcanvas.dismiss()">
                    <a class="nav-link" (click)="go(getChannelURL(i))" title="{{ i.title }}" (click)="sendGAOrganizationFavoriteClickEvent(i.title)" data-bs-dismiss="offcanvas" aria-label="Close">
                      {{ i.title }} @if (isEmailIcon(i) && hasUnreadCount) {
                      <span class="badge rounded-pill text-bg-danger bg-danger">{{unreadCount}}</span>
                    }
                  </a>
                </li>
              }
            }
            @for( i of internalIcons; track i.id ) {
              @if ( !i.is_college ) {
                <li class="nav-item" routerLinkActive="active" draggable="false" (click)="offcanvas.dismiss()">
                  <a class="nav-link" [routerLink]="['/',getIconLink(i)]" title="{{ i.title }}" data-bs-dismiss="offcanvas" aria-label="Close" (click)="sendGAOrganizationFavoriteClickEvent(i.title)">{{ i.title }}</a>
                </li>
              }
            }
          </ul>
          <div class="h6 ps-3 pt-3 border-top text-uppercase">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
              <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
            </svg> Favourites
          </div>
          <ul class="nav flex-column">
            @for (f of favorites; track f; let i = $index) {
              <li class="nav-item" routerLinkActive="active" draggable="true"
                [ngClass]="{'list-group-item-success': this.currentDragged == f.id}"
                (drag)="onDrag($event)"
                (dragstart)="onDragStart($event)"
                (dragenter)="onDragEnter($event)"
                (dragover)="onDragOver($event)"
                (dragend)="onDragEnd($event)"
                (drop)="onDrop($event)">
                @if ( f.is_favorite && f.is_redirect ) {
                  <button id="favorite_{{i}}" class="nav-link d-block w-100 text-start" title="{{ f.title }}" [ngClass]="{'invisible-text': this.currentDragged == f.id}"
                    [ngbPopover]="popContent"
                    [popoverTitle]="popTitle"
                    triggers="manual"
                    popoverClass="popover-info"
                    [popoverContext]="{ channel: f, newTitle: getRedirectTitle(f) }"
                    #pmobile="ngbPopover"
                    [autoClose]="'outside'"
                    (click)="pmobile.open()"
                  >{{ f.title }}</button>
                  }  @else {
                  <a id="favorite_{{i}}" class="nav-link d-block w-100" [routerLink]="['/',f.goname]" title="{{ f.title }}" (click)="sendGAFavoriteClickEvent(f.title)"
                    [ngClass]="{'invisible-text': this.currentDragged == f.id}">
                    {{ f.title }}
                  </a>
                }
              </li>
            }
          </ul>
          @if (myCollege.length>0) {
            <div class="h6 ps-3 pt-3 border-top text-uppercase">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bank2" viewBox="0 0 16 16">
                <path
                  d="M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916l-7.5-5zM12.375 6v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1H.5z" />
                </svg> My College
              </div>
            }
            @if (myCollege.length>0) {
              <ul class="nav flex-column">
                @for (c of myCollege; track c) {
                  <li class="nav-item" routerLinkActive="active" (click)="offcanvas.dismiss()">
                    @if (c.is_icon) {
                      <a class="nav-link" [routerLink]="['/',getIconLink(c)]" title="{{ c.title }}" (click)="sendGAMyCollegeClickEvent(c.title)" data-bs-dismiss="offcanvas" aria-label="Close">{{ c.title }}</a>
                    }
                    @if (!c.is_icon) {
                      <a class="nav-link" [routerLink]="['/',c.goname]" title="{{ c.title }}" (click)="sendGAMyCollegeClickEvent(c.title)" data-bs-dismiss="offcanvas" aria-label="Close">{{ c.title }}</a>
                    }
                  </li>
                }
              </ul>
            }
            @if (recommendedChannels.length>0) {
              <div class="h6 ps-3 pt-3 border-top text-uppercase">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-check-fill" viewBox="0 0 16 16">
                  <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/>
                  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
                </svg> Recommended
              </div>
            }
            @if (recommendedChannels.length>0) {
              <ul class="nav flex-column" aria-label="My College Links">
                @for (c of recommendedChannels; track c) {
                  <li class="nav-item" routerLinkActive="active" data-cy="mycollege-link" (click)="offcanvas.dismiss()">
                    @if (c.is_icon) {
                      <a class="nav-link" [routerLink]="['/',getIconLink(c)]" title="{{ c.title }}" (click)="sendGARecommenderClickEvent(c.title)" data-bs-dismiss="offcanvas" aria-label="Close">{{ c.title }}</a>
                    }
                    @if (!c.is_icon) {
                      <a class="nav-link" [routerLink]="['/',c.goname]" title="{{ c.title }}" (click)="sendGARecommenderClickEvent(c.title)" data-bs-dismiss="offcanvas" aria-label="Close">{{ c.title }} @if (c.is_new) {
                        <span class="badge bg-warning text-black">NEW</span>
                      }</a>
                    }
                  </li>
                }
              </ul>
            }
            @if (recentlyViewed.length>0) {
              <div class="h6 ps-3 pt-3 border-top text-uppercase">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                </svg> Recently Viewed
              </div>
            }
            @if (recentlyViewed.length>0) {
              <ul class="nav flex-column">
                @for (rv of recentlyViewed; track rv) {
                  <li class="nav-item" routerLinkActive="active" (click)="offcanvas.dismiss()">
                    <a class="nav-link" [routerLink]="['/',rv.goname]" title="{{ rv.title }}" (click)="sendGARecentlyViewedClickEvent(rv.title)" data-bs-dismiss="offcanvas" aria-label="Close">{{ rv.title }}</a>
                  </li>
                }
              </ul>
            }

          </div>
        </div>
      </ng-template>
    </nav>
  } @else {
    <nav id="navigation" aria-label="main menu" tabindex="-1">
      <ul class="nav flex-column" aria-label="USask Favorites">
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" aria-current="page" [routerLink]="['/']"><svg xmlns="http://www.w3.org/2000/svg" width="1em" fill="currentColor" class="bi bi-house-door-fill" viewBox="0 0 16 16">
            <path d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5z"></path>
          </svg> Home</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/services']"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-fill" viewBox="0 0 16 16">
            <path
              d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z" />
            </svg> Apps and services</a>
          </li>
          @if ( hasMyClasses ) {
            <li class="nav-item d-none" routerLinkActive="active">
              <a class="nav-link" [routerLink]="['/myclasses']">
              My Classes</a>
            </li>
          }
          @for( i of externalIcons; track i.id ) {
            @if ( !i.is_college ) {
              <li class="nav-item" routerLinkActive="active" data-cy="external-icon-link">
                <a class="nav-link" href="{{ getChannelURL(i) }}" target="_blank" rel="noopener noreferrer" title="{{ i.title }}" (click)="sendGAOrganizationFavoriteClickEvent(i.title)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right float-end fs-5" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z" />
                    <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z" />
                  </svg>
                  {{ i.title }} @if (isEmailIcon(i) && hasUnreadCount) {
                  <span class="badge rounded-pill text-bg-danger bg-danger">{{unreadCount}}</span>
                }
              </a>
            </li>
          }
        }
        @for( i of internalIcons; track i.id ) {
          @if ( !i.is_college ) {
            <li class="nav-item" routerLinkActive="active" data-cy="internal-icon-link">
              <a class="nav-link" [routerLink]="['/',getIconLink(i)]" title="{{ i.title }}" (click)="sendGAOrganizationFavoriteClickEvent(i.title)">
                {{ i.title }}
              </a>
            </li>
          }
        }
      </ul>

      @if (favorites.length > 0) {
        <div class="h6 ps-3 pt-3 border-top text-uppercase">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
            <path
              d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
            </svg> Favourites
          </div>
        }
        <!--    <div *ngIf="favorites.length == 0">-->
        <!--        <p class="ms-3 text-muted">Favorite channels will appear here</p>-->
      <!--    </div>-->
      <ul class="nav flex-column" aria-label="My Favorite links" id="favorites_menu">

        @for (f of favorites; track f; let i = $index) {
          <li class="nav-item" routerLinkActive="active" data-cy="favorite-link"
            (click)="sendGAFavoriteClickEvent(f.title)"
            [ngClass]="{'bg-paws': this.currentDragged == f.id}"
            draggable="true"
            (drag)="onDrag($event)"
            (dragstart)="onDragStart($event)"
            (dragenter)="onDragEnter($event)"
            (dragover)="onDragOver($event)"
            (dragend)="onDragEnd($event)"
            (drop)="onDrop($event)"
            >
            @if ( f.is_favorite && f.is_redirect ) {
              <button id="favorite_{{i}}" class="nav-link w-100 text-start" title="{{ f.title }}" [ngClass]="{'invisible-text': this.currentDragged == f.id}"
                placement="end"
                [ngbPopover]="popContent"
                [popoverTitle]="popTitle"
                triggers="manual"
                popoverClass="popover-info"
                [popoverContext]="{ channel: f, newTitle: getRedirectTitle(f) }"
                #p="ngbPopover"
                [autoClose]="'outside'"
                (click)="p.open()"
              >{{ f.title }}</button>
              }  @else {
              <a id="favorite_{{i}}" class="nav-link d-block w-100" [routerLink]="['/',f.goname]" title="{{ f.title }}"
                [ngClass]="{'invisible-text': this.currentDragged == f.id}">
                {{ f.title }}
              </a>
            }
          </li>
        }
      </ul>
      @if (myCollege.length>0) {
        <div class="h6 ps-3 pt-3 border-top text-uppercase" data-cy="mycollege-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bank2" viewBox="0 0 16 16">
            <path
              d="M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916l-7.5-5zM12.375 6v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1H.5z" />
            </svg> My College
          </div>
        }
        @if (myCollege.length>0) {
          <ul class="nav flex-column" aria-label="My College Links">
            @for (c of myCollege; track c) {
              <li class="nav-item" routerLinkActive="active" data-cy="mycollege-link">
                @if (c.is_icon) {
                  <a class="nav-link" [routerLink]="['/',getIconLink(c)]" title="{{ c.title }}" (click)="sendGAMyCollegeClickEvent(c.title)">{{ c.title }}</a>
                }
                @if (!c.is_icon) {
                  <a class="nav-link" [routerLink]="['/',c.goname]" title="{{ c.title }}" (click)="sendGAMyCollegeClickEvent(c.title)">{{ c.title }}</a>
                }
              </li>
            }
          </ul>
        }
        @if (recommendedChannels.length>0) {
          <div class="h6 ps-3 pt-3 border-top text-uppercase">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-check-fill" viewBox="0 0 16 16">
              <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/>
              <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
            </svg> Recommended
          </div>
        }
        @if (recommendedChannels.length>0) {
          <ul class="nav flex-column" aria-label="My College Links">
            @for (c of recommendedChannels; track c) {
              <li class="nav-item" routerLinkActive="active" data-cy="mycollege-link">
                @if (c.is_icon) {
                  <a class="nav-link" [routerLink]="['/',getIconLink(c)]" title="{{ c.title }}" (click)="sendGARecommenderClickEvent(c.title)">{{ c.title }}</a>
                }
                @if (!c.is_icon) {
                  <a class="nav-link" [routerLink]="['/',c.goname]" title="{{ c.title }}" (click)="sendGARecommenderClickEvent(c.title)">{{ c.title }} @if (c.is_new) {
                    <span class="badge bg-warning text-black">New</span>
                  }</a>
                }
              </li>
            }
          </ul>
        }
        @if (recentlyViewed.length>0) {
          <div class="h6 ps-3 pt-3 border-top text-uppercase">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
            </svg> Recently Viewed
          </div>
        }
        @if ( recentlyViewed.length > 0 ) {
          @if (recentlyViewed.length>0) {
            <ul class="nav flex-column" aria-label="Recently viewed links">
              @for (rv of recentlyViewed; track rv) {
                <li class="nav-item" routerLinkActive="active" data-cy="recently-viewed-link">
                  <a class="nav-link" [routerLink]="['/',rv.goname]" title="{{ rv.title }}" (click)="sendGARecentlyViewedClickEvent(rv.title)">{{ rv.title }}</a>
                </li>
              }
            </ul>
          }
        }
        <p class="ps-3 pt-3 mt-3 border-top d-none">
          <small>Last Published:<br />{{ pubDate }}</small><br />
          <small>Revision: {{ revision }}</small>
        </p>

      </nav>
    }

    <ng-template #popContent let-channel="channel" let-newTitle="newTitle">
      <p class="mb-0">Your favourited channel <b>"{{ channel.title }}"</b> has been renamed or its content has moved to <b>"{{ newTitle }}"</b>
      <br /><br />
      <span class="btn btn-primary me-2" (click)="updateFavoriteAndGo(channel)">Update Favourite</span>
      <span class="btn btn-secondary text-black" (click)="deleteFavorite(channel)">Remove Favourite</span>
    </p>
  </ng-template>
  <ng-template #popTitle>
    <b>This channel has moved</b>
  </ng-template>


